<style scoped lang="scss">

.blok-detail > p,
.blok-detail > .row > .col > p {
  text-align: left;
}


.table-primary > tbody > tr > td:first-child {
  text-align: left;
}
.table-primary > tbody > tr > .title {
  font-weight: 600 !important;
}

.table-primary > tbody > tr > .sub-title {
  padding-left: 2rem !important;
  font-weight: 400 !important;
  white-space: nowrap;
}

.questionnaire{
  min-height: 67vh;
  display: flex;
  flex-direction: column;
  border:1px solid #b8b8b8;
  position: relative;
  background:white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  &-navigation{
    display: flex;
    border-bottom:none;
    border-top:1px solid #e0e0e0;
    // border-bottom:1px solid #e0e0e0;
    background: white;
    padding: 0px 50px 0px 50px;

    & .item{

      font-size: 12px;
      font-weight: 500;
      padding: 5px 15px;
      // margin:-1px;
      border-left:1px solid #e0e0e0;
      &:last-child{
        border-right:1px solid #e0e0e0;
      }
      &.active{
        // color: #2d2d2d;
        color: white;
        // background: #e5e5e5;
        background: #005f4f;
        border:1px solid #005f4f;
      }
      &.invalid{
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #dc3545;
        border-color: rgb(255, 214, 214);
      }
      &.status{
        font-weight: 600;
        background: white;
        margin-left: auto;
        border:none;
        font-size: 12px;
        padding-right:0 ;
        & div{
          border-radius:5px ;
          padding: 1px 3px;
        }
        & .draft{
          background-color: #cccccc;
          color: #424242;
          border: 1px solid #cccccc;
        }
        
        & .submitted{
          color: #1976D2;
          background: #E3F2FD;
          border: 1px solid #90CAF9;
          
          &.darker{
            background: #006aff;
            color: white;
          }
        }
        & .under-review{
          color: #7b6400;
          background: #ffe600;
          border: 1px solid #d8c300;
        }
        & .correction-required, &.revised{
          color: #7B1FA2;
          background: #F3E5F5;
          border: 1px solid #CE93D8;
          
        }
        & .rejected{
          background: rgb(253, 208, 208);
          color: rgb(201, 0, 0);
          border: 1px solid rgb(255, 143, 143);
        }
        & .approved{
          font-weight: 600;
          background: #c4ffc4;
          color: rgb(22, 139, 22);
          border: 1px solid rgb(97, 213, 97);
        }
        & .published{
          font-weight: 500;
          background: rgb(192, 255, 192);
          color: rgb(25, 136, 25);
          border: 1px solid rgb(154, 234, 154);
        }

      }
      
    }
    

    & .button-navigation{
      & .prev{
        padding: 5px 15px;
      }
      & .next{
        padding: 5px 15px;
        background: teal;
        color: white;
      }
      
    }
  }
  &.entry-mode{
    & .blok-detail {
      padding: 20px 25px;

      & .question{
        border:none !important;
      }
      
    }
  }
  & .blok{
    & .blok-title {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: 700;
      background: #e5e5e5;
      padding: 0.25rem 0.5rem;
      text-align: center;

      border-top:1px solid #b8b8b8;
      border-bottom:1px solid #b8b8b8;
      text-transform: uppercase;
    }
    &:first-child .blok-title{
      border-top: none;
    }
  }
  & .blok-detail {
    padding: 20px 25px;

    & .question{
      padding: 10px 0px;
      &:first-child{
        padding-top: 0;
      }
      &:last-child{
        padding-bottom: 0;
      }
      &:not(:last-child){
        border-bottom: 1px solid rgb(210, 210, 210);
      }
      &__name{
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 0rem;
        color: #212121;
      }
      &__value{
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #525252;

        & input, & .vue-treeselect, & textarea, & div[role="radiogroup"], & ul{
          margin-top: 3px !important;
        }
        & div[role="radiogroup"]{
          margin-left: 3px !important;
        }
        & .custom-checkbox{
          margin-left: 3px !important;
        }
        & ul{
          margin-left: -35px !important;
        }
      }
      & ul.list{
        list-style-type: none;
        margin-left: -40px;
        margin-bottom: 0;

        & li::before{
          content: '- ';
        }
        & li:only-child::before{
          content: '';
        }
      }
    }

    &  p.question {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 0rem;
      color: #212121;
    }
    &  p {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 0rem;
      color: #525252;
    }
    
  }
  &__status{
		margin-top: -7px;
    margin-left: 4px;
		padding:3px 5px;
    letter-spacing: .3px;
    font-size: 11px;
		border-radius: 5px 0px 5px 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 700;
		border: 1px solid #cccccc;
		background-color: #cccccc;
		color: #424242;

    &2{
      border-radius: 0px 0px 0px 15px;
      position: absolute;
      top:-1px;
      right:-1px;
      padding:5px 10px;
    }
		&.draft, &2.draft{
      color: #424242;
      background: #cccccc;
      border: 1px solid #bbbbbb;
    }
		&.submitted, &2.submitted{
      color: #1976D2;
      background: #E3F2FD;
      border: 1px solid #90CAF9;
      
      &.darker{
        background: #006aff;
        color: white;
      }
    }
    &.under-review, &2.under-review{
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border: 1px solid #dfcd2b;
    }
    &.correction-required, &.revised, &2.correction-required, &2.revised{
      color: #7B1FA2;
      background: #F3E5F5;
      border: 1px solid #CE93D8;
      
    }
    &.rejected, &2.rejected{
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border: 1px solid rgb(255, 143, 143);
    }
    &.approved, &2.approved{
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border: 1px solid rgb(97, 213, 97);
    }
    &.published, &2.published{
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border: 1px solid rgb(154, 234, 154);
    }

	}
  &__body{
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }
  &__footer{
    border-top:1px solid #b8b8b8;
    bottom:0;
    display: flex;
    padding: 10px 20px;
  }
  
}
#detail-pelaporan{
  font-family: 'Manrope';
  background: #f9f9f9;
  min-height: calc(100vh - 45px);
}

/* ============================================================
   History Status (ms_keg_histories)
   ============================================================ */
.history-status {
  margin-top: 12px;

  &__item {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-left: 3px solid #e0e0e0;
    background: #fafafa;
    border-radius: 4px;
  }

  &__number {
    font-size: 11px;
    font-weight: 600;
    color: #424242;
    min-width: 18px;
  }

  &__badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .3px;
    border: 1px solid transparent;

    &--draft {
      color: #424242;
      background: #cccccc;
      border-color: #bbbbbb;
    }
    &--submitted {
      color: #1976D2;
      background: #E3F2FD;
      border-color: #90CAF9;
    }
    &--under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border-color: #dfcd2b;
    }
    &--correction-required,
    &--revised {
      color: #7B1FA2;
      background: #F3E5F5;
      border-color: #CE93D8;
    }
    &--rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border-color: rgb(255, 143, 143);
    }
    &--approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border-color: rgb(97, 213, 97);
    }
    &--published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border-color: rgb(154, 234, 154);
    }
  }

  &__info {
    font-size: 10px;
    color: #757575;
    margin-top: 4px;
    margin-left: 18px;
    font-style: italic;
  }

  &__rejection {
    font-size: 11px;
    color: #c9302c;
    margin-top: 4px;
    margin-left: 18px;
    padding: 4px 6px;
    background: #fff5f5;
    border-radius: 3px;
    border: 1px solid #f5c6cb;
  }
}
</style>
<template>
  <div id="detail-pelaporan" class="content content--borderless">
    <div class="content__breadcrumbs">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
    </div>
    <div class="page-control--secondary" v-if="!isLoading && msKeg ">
      <div class="page-control__body">
        <div class="page-control__left">
          <button class="button button--text button--action mr-2"  id="backUsulanList" @click="$router.back()">
              <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
          </button>
          <b-popover target="backUsulanList" triggers="hover" placement="bottom">
            <template #title>Kembali ke halaman daftar usulan</template>
            Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika kembali isian ada akan hilang
          </b-popover>
          <div class="my-2">
            <div class="d-flex align-items-start" style="font-family:'Manrope';font-weight:600;font-size:16px;color:#032F05;line-height:1">
              <div>
                Detil Metadata Kegiatan <span class="text-primary" >{{data.judul_kegiatan}}</span> 
              </div>
            </div>
            <div class="d-flex mt-1">
              <div class="d-flex align-items-center text-12 text-700">
                <VueFeather type="briefcase" size="12" stroke-width="2" style="display:block"></VueFeather> &nbsp;
                {{msKeg.produsen_data_name}}
              </div>
            </div>
            
          </div>
        </div>
        <div class="page-control__center"></div>
        <div class="page-control__right align-items-center">
          <!-- Tombol Catatan Pemeriksaan (hanya tampil saat Tab Metadata Kegiatan aktif) -->
          <button 
            v-if="tab.index == 0 && ((form && form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0) || (msKegHistories && msKegHistories.length > 0))"
            class="button mr-2" 
            :variant="isReviewOpen ? 'primary' : 'outlined'" 
            size="sm" 
            @click="isReviewOpen = !isReviewOpen"
            title="Tampilkan / Sembunyikan Catatan Pemeriksaan & Histori"
          >
            <VueFeather type="mail" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Catatan Pemeriksaan
            <span v-if="(form && form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
              {{ (form && form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
            </span>
          </button>

          <!-- Tombol Sync & Tambah Variabel (hanya tampil saat Tab Variabel aktif) -->
          <b-button v-if="tab.index == 1 && canSync" 
            :disabled="isKegiatanDitolakAtauDisetujui || syncState.isSyncing"
            class="button button--secondary button--sm mr-2" 
            @click="openSyncModal('variabel')"
          >
            <VueFeather type="refresh-cw" size="14" stroke-width="2" style="display:block" :class="{'fa-spin': syncState.isSyncing && syncState.type === 'variabel'}"></VueFeather> &nbsp;&nbsp;Sync Variabel
          </b-button>
          <b-button v-if="AddVariableVisible" 
            :disabled="isKegiatanDitolakAtauDisetujui"
            class="button button--primary button--sm" :to="'/metadata/usulan/kegiatan/'+msKeg.id+'/variabel'"
          >
            <VueFeather type="plus" size="14" stroke-width="2" style="display:block"></VueFeather> &nbsp;&nbsp;Tambah MS-Variabel
          </b-button>

          <!-- Tombol Sync & Tambah Indikator (hanya tampil saat Tab Indikator aktif) -->
          <b-button v-if="tab.index == 2 && canSync" 
            :disabled="isKegiatanDitolakAtauDisetujui || syncState.isSyncing"
            class="button button--secondary button--sm mr-2" 
            @click="openSyncModal('indikator')"
          >
            <VueFeather type="refresh-cw" size="14" stroke-width="2" style="display:block" :class="{'fa-spin': syncState.isSyncing && syncState.type === 'indikator'}"></VueFeather> &nbsp;&nbsp;Sync Indikator
          </b-button>
          <b-button v-if="AddIndicatorVisible" 
            :disabled="isKegiatanDitolakAtauDisetujui"
            class="button button--primary button--sm" :to="'/metadata/usulan/kegiatan/'+msKeg.id+'/indikator'"
          >
            <VueFeather type="plus" size="14" stroke-width="2" style="display:block"></VueFeather> &nbsp;&nbsp;Tambah MS-Indikator
          </b-button>
        </div>
      </div>
      
      <div class="page-control__footer" >
        <div class="tabs-control">
          <div class="tabs-control__item" :class="tab.index  == index ? 'active' : ''" 
            v-for="(item,index) in tab.items" :key="index" @click="tabIndexChanged(index)"
          >
            {{item.name}} <span v-if="index!=0" class="count">{{item.count}}</span>
          </div>
          
        </div>
      </div>
    </div>

    <div v-if="isLoading" class="content__loading" style="border:none;box-shadow:none">
      <img src="@/assets/icons/loading-plane.gif" width="200" height="200" style="margin-top:-60px"/>
      <div style="margin-top:-60px">
        Sedang mengambil data ke server, harap tunggu sebentar....
      </div> 
    </div>
    <div v-else class="content__body mt-2 mb-5">
      <b-tabs v-model="tab.index" nav-class="d-none" content-class="p-0" v-if="msKeg">
        <b-tab>
        <div class="tags tags--secondary">
          <div class="tag tag--secondary "> 
            <div class="tag__field">ID</div>
            <div class="tag__value">{{msKeg.id}}</div>
          </div>
          <div class="tag tag--primary">
            <div class="tag__field">Pelapor</div>
            <div class="tag__value">{{msKeg.requester_details ? msKeg.requester_details.name : msKeg.requested_by}}</div>
          </div>
          <div class="tag tag--secondary "> 
            <div class="tag__field">Tanggal Usulan</div>
            <div class="tag__value">{{msKeg.created_at | formatDate}}</div>
          </div>
        </div>
          <b-row class="mt-2">
            <b-col>
              <div class="questionnaire">
                <div :class="'questionnaire__status2 '+statusFormatterStyle(form.status)">{{statusFormatter(form.status)}}</div>
                <div class="blok">
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">Judul Kegiatan :</div>
                      <div class="question__value">
                        {{  capitalize(data.judul_kegiatan)}}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">Tahun:</div>
                      <div class="question__value">
                        {{ data.tahun }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">Cara Pengumpulan Data:</div>
                      <div class="question__value">
                        {{ capitalize(data.cara_pengumpulan_data) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">Sektor Kegiatan:</div>
                      <div class="question__value">
                        {{ capitalize(data.sektor_kegiatan) }}
                      </div>
                    </div>
                    <div class="question" v-if="form.jenis_statistik == 'STATISTIK_SEKTORAL'">
                      <div class="question__name">Apakah mendapatkan rekomendasi kegiatan statistik dari BPS?</div>
                      <div class="question__value">
                        {{ capitalize(data.identitas_rekomendasi ? 'Ya' : 'Tidak') }}
                      </div>
                      <div  class="question__name mt-2" v-if="data.identitas_rekomendasi">Identitas Rekomendasi:</div>
                      <div class="question__value" v-if="data.identitas_rekomendasi">
                        {{ capitalize(data.identitas_rekomendasi) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div id="blok_i" class="blok">
                  <div class="blok-title"> I. Penyelenggara</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">1.1. Instansi Penyelenggara:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_i.instansi_penyelanggara) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name"> 1.2. Alamat Lengkap Instansi Penyelenggara:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.alamat) }}
                      </div>
                      <b-row class="mt-2" >
                        <b-col>
                          <div class="question">
                            <div class="question__name">Telepon:</div>
                            <div class="question__value">
                              {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.telepon) }}
                            </div>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="question">
                            <div class="question__name">Faksmile:</div>
                            <div class="question__value">
                              {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.faksimile) }}
                            </div>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="question">
                            <div class="question__name">Email:</div>
                            <div class="question__value">
                              {{ data.blok_i.alamat_instansi_penyelenggara.email }}
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
                

                <div id="blok_ii" class="blok">
                  <div class="blok-title">II. Penanggung Jawab</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">2.1. Unit Eselon Penanggung Jawab:</div>
                      <b-row class="mt-2" >
                        <b-col>
                          <div class="question">
                            <div class="question__name">Eselon 1:</div>
                            <div class="question__value">
                              {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon1) }}
                            </div>
                          </div>
                        </b-col>
                        <b-col>
                          <div class="question">
                            <div class="question__name">Eselon 2:</div>
                            <div class="question__value">
                              {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon2) }}
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <div class="question">
                      <div class="question__name">2.2. Penanggung Jawab Teknis (setingkat Eselon 3):</div>
                      <div class="question">
                        <div class="question__name">Nama:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_ii.penanggung_jawab_teknis.nama) }}
                        </div>

                        <div  class="question__name mt-2">Jabatan:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_ii.penanggung_jawab_teknis.jabatan) }}
                        </div>

                        <div  class="question__name mt-2">Alamat:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_ii.penanggung_jawab_teknis.alamat) }}
                        </div>

                        <b-row class="mt-2" >
                          <b-col>
                              <div class="question__name">Telepon:</div>
                              <div class="question__value">
                                {{ capitalize(data.blok_ii.penanggung_jawab_teknis.telepon) }}
                              </div>
                          </b-col>
                          <b-col>
                              <div class="question__name">Faksmile:</div>
                              <div class="question__value">
                                {{ capitalize(data.blok_ii.penanggung_jawab_teknis.faksimile) }}
                              </div>
                          </b-col>
                          <b-col>
                              <div class="question__name">Email:</div>
                              <div class="question__value">
                                {{ data.blok_ii.penanggung_jawab_teknis.email }}
                              </div>
                          </b-col>
                        </b-row>
                      </div>
                      
                    </div>
                  </div>
                </div>
                

                <div id="blok_iii" class="blok">
                  <div class="blok-title">III. Perencanaan dan Persiapan</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">3.1. Latar Belakang Kegiatan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iii.latar_belakang_kegiatan) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">3.2. Tujuan Kegiatan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iii.tujuan_kegiatan) }}
                      </div>
                    </div>
                    <div class="question border-bottom-0">
                      <div class="question__name">3.3. Rencana Jadwal Kegiatan:</div>
                      <div class="table-wrapper mt-2">
                        <table  class="table table--light table--bordered">
                          <thead>
                            <tr>
                              <th colspan="2"></th>
                              <th class="text-center">Tanggal Mulai</th>
                              <th class="text-center">Tanggal Selesai</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-bold text-right w-max-25 w-26" style="border-right:0 !important;padding-right:0 !important">A.</td>
                              <td colspan="3" class="text-bold">Perencanaan</td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="pl-2">1.  &nbsp;Perencanaan Kegiatan</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">2. &nbsp;Desain</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr class="text-bold">
                              <td class="text-right" style="border-right:0 !important;padding-right:0 !important">B.</td>
                              <td colspan="3">Pengumpulan</td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">3. &nbsp;Pengumpulan Data</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr class="text-bold"> 
                              <td class="text-right" style="border-right:0 !important;padding-right:0 !important">C.</td>
                              <td colspan="3">Pemeriksaan</td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">4. &nbsp;Pengolahan Data</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr class="text-bold">
                              <td class="text-right"  style="border-right:0 !important;padding-right:0 !important">D.</td>
                              <td colspan="3">Penyebarluasan</td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">5. &nbsp;Analisis</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">6. &nbsp;Diseminasi Hasil</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td style="border-right:0 !important"></td>
                              <td class="sub-title">7. &nbsp;Evaluasi</td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi" v-bind:key="index">
                                  {{item.awal | formatDate}}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="mb-0" v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi" v-bind:key="index">
                                  {{item.akhir | formatDate}}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">3.4. Variabel (Karakteristik) yang Dikumpulkan:</div>
                      <div class="table-wrapper mt-2">
                        <b-table
                          class="table--light table--bordered"
                          :items="data.blok_iii.variabel_yang_dikumpulkan"
                          :fields="[
                            {key:'no',  thClass:'w-40', tdClass:'text-center'},
                            {key:'nama', label:'Nama Variabel (Kharakteristik)', thClass:''},
                            'konsep',
                            'definisi',
                            {key:'referensi_waktu',label:'Referensi Waktu (periode Enumerasi)', thClass:''}
                          ]"
                        >
                          <template #cell(no)="data"> {{ data.index + 1 }}. </template>
                          <template #empty>
                            <div class="table__empty">
                              <div>
                                <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                  Variabel belum diinput
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
                

                <div id="blok_iv" class="blok">
                  <div class="blok-title">IV. Desain Kegiatan</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">4.1. Kegiatan Ini Dilakukan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iv.kegiatan_ini_dilakukan) }}
                      </div>
                    </div>
                    
                    <div class="question" v-if="data.blok_iv.kegiatan_ini_dilakukan == 'BERULANG'">
                      <div class="question__name">4.2. Frekuensi Penyelenggaraan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iv.frekuensi_penyelanggara) }}
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">4.3. Tipe Pengumpulan Data:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iv.tipe_pengumpulan_data) }}
                      </div>
                    </div>
                    
                    <div class="question">
                      <div class="question__name">4.4. Cakupan Wilayah Pengumpulan Data:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_iv.cakupan_wilayah_pengumpulan_data) }}
                      </div>
                    </div>

                    <div class="question border-bottom-0" v-if="data.blok_iv.cakupan_wilayah_pengumpulan_data == 'SEBAGIAN_WILAYAH_INDONESIA'">
                      <div class="question__name">4.5. Wilayah Kegiatan:</div>
                      <div class="table-wrapper mt-2">
                        <b-table
                          class="table--light table--bordered"
                          :items="data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data"
                          :fields="table.wilayahFields"
                        >
                          <template #cell(no)="data"> {{ data.index + 1 }}. </template>
                        </b-table>
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">4.6. Metode Pengumpulan Data:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li v-if="data.blok_iv.metode_pengumpulan_data.wawancara">Wawancara</li>
                          <li v-if="data.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri">Mengisi Kuesioner Sendiri</li>
                          <li v-if="data.blok_iv.metode_pengumpulan_data.pengamatan">Pengamatan</li>
                          <li v-if="data.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder">Pengumpulan Data Sekunder</li>
                          <li v-if="data.blok_iv.metode_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya}}</li>
                        </ul> 
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">4.7. Sarana Pengumpulan Data:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.papi">Paper-assisted Personal Interviewing (PAPI)</li>
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.capi">Computer-assisted Personal Interviewing (CAPI)</li>
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.cati">Computer-assisted Telephones Interviewing (CATI)</li>
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.cawi">Computer Aided Web Interviewing (CAWI)</li>
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.mail">Mail</li>
                          <li  v-if="data.blok_iv.sarana_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya}}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">4.8. Unit Pengumpulan Data:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li v-if="data.blok_iv.unit_pengumpulan_data.individu">Individu</li>
                          <li v-if="data.blok_iv.unit_pengumpulan_data.rumah_tangga">Rumah Tangga</li>
                          <li v-if="data.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                          <li v-if="data.blok_iv.unit_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.unit_pengumpulan_data.unit_pengumpulan_data_lainnya}}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                

                <div id="blok_v" class="blok">
                  <div class="blok-title" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                    <div>V. Desain Sampel</div>
                    <div class="text-12 text-semi-bold" style="text-transform:none">Diisi jika cara pengumpulan data adalah Survei</div>
                  </div>
                  <div class="blok-detail" v-if="data.cara_pengumpulan_data == 'SURVEI'">
                    <div class="question">
                      <div class="question__name">5.1. Jenis Rancangan Sampel:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.jenis_rancangan_sampel) }}
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">5.2. Metode Pemilihan Sampel Tahap Terakhir:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.metode_pemilihan_sampel_tahap_terakhir) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.3. Metode Yang Digunakan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.metode_yang_digunakan) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.4. Kerangka Sampel Tahap Terakhir:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.kerangka_sampel_tahap_terakhir) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.5. Fraksi Sampel Keseluruhan:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.fraksi_sampel_keseluruhan) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.6. Nilai Perkiraan Sampling Error Variabel Utama:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.nilai_perkiraan_sampling_error_variabel_utama) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.7. Unit Sampel:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.unit_sampel) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">5.8. Unit Observasi:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_v.unit_observasi) }}
                      </div>
                    </div>
                  </div>
                </div>
                

                <div id="blok_vi" class="blok">
                  <div class="blok-title">VI. Pengumpulan Data</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">6.1. Apakah Melakukan Uji Coba (Pilot Survey)?</div>
                      <div class="question__value">
                        {{ data.blok_vi.apakah_melakukan_uji_coba==true? "Ya":"Tidak" }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.2. Metode Pemeriksaan Kualitas Pengumpulan Data:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali">Kunjungan Kembali</li>
                          <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi">Supervisi</li>
                          <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce">Task Force</li>
                          <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya">Lainnya: {{data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya}}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.3. Apakah Melakukan Penyesuaian Nonrespon?</div>
                      <div class="question__value">
                        {{ data.blok_vi.apakah_melakukan_penyesuaian_nonrespon==true?"Ya":"Tidak" }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.4. Petugas Pengumpulan Data:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_vi.petugas_pengumpulan_data) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data) }}
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.6. Jumlah Petugas:</div>
                      <div >
                        <div class="d-flex">
                            <div class="question__value w-200">Supervisor/penyelia/pengawas</div>
                            <div class="question__value">
                              : {{ data.blok_vi.jumlah_petugas_supervisor }} orang
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Pengumpul data/enumerator</div>
                            <div class="question__value">
                              : {{ data.blok_vi.jumlah_petugas_enumerator }} orang
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">6.7. Apakah Melakukan Pelatihan Petugas?</div>
                      <div class="question__value">
                        {{ data.blok_vi.apakah_melakukan_pelatihan_petugas ? "Ya":"Tidak" }}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div id="blok_vii" class="blok">
                  <div class="blok-title">VII. Pengolahan Dan Analisis</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">7.1. Tahapan Pengolahan Data:</div>
                      <div>
                        <div class="d-flex">
                            <div class="question__value w-200">Penyuntingan (Editing)</div>
                            <div class="question__value">
                              : {{data.blok_vii.tahapan_pengolahan_data.editing ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Penyandian (Coding)</div>
                            <div class="question__value">
                              : {{data.blok_vii.tahapan_pengolahan_data.coding ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Data Entry</div>
                            <div class="question__value">
                              : {{data.blok_vii.tahapan_pengolahan_data.data_entry ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Penyahihan (Validasi)</div>
                            <div class="question__value">
                              : {{data.blok_vii.tahapan_pengolahan_data.validasi ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="question">
                      <div class="question__name">7.2. Metode Analisis:</div>
                      <div class="question__value">
                        {{ capitalize(data.blok_vii.metode_analisis) }}
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">7.3. Unit Analisis:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li v-if="data.blok_vii.unit_analsis.individu">Individu</li>
                            <li v-if="data.blok_vii.unit_analsis.rumah_tangga">Rumah Tangga</li>
                            <li v-if="data.blok_vii.unit_analsis.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                            <li v-if="data.blok_vii.unit_analsis.lainnya">Lainnya: {{data.blok_vii.unit_analsis.unit_analisis_lainnya}}</li>
                          </ul>
                      </div>
                    </div>

                    <div class="question">
                      <div class="question__name">7.4. Tingkat Penyajian Hasil Analisis:</div>
                      <div class="question__value">
                        <ul class="list">
                          <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.nasional">Nasional</li>
                          <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.provinsi">Provinsi</li>
                          <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota">Kabupaten/Kota</li>
                          <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya">Lainnya: {{data.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya}}</li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </div>
                
                <div id="blok_viii" class="blok">
                  <div class="blok-title">VIII. Diseminasi Hasil</div>
                  <div class="blok-detail">
                    <div class="question">
                      <div class="question__name">8.1. Produk Kegiatan yang Tersedia untuk Umum</div>
                      <div>
                        <div class="d-flex">
                            <div class="question__value w-200">Tercetak (Hardcopy)</div>
                            <div class="question__value">
                              : {{data.blok_viii.ketersediaan_produk_tercetak ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Digital (Softcopy)</div>
                            <div class="question__value">
                              : {{data.blok_viii.ketersediaan_produk_digital ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="question__value w-200">Data Mikro</div>
                            <div class="question__value">
                              : {{data.blok_viii.ketersediaan_produk_mikrodata ? 'Ya':'Tidak'}}
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="question" 
                      v-if="(data.blok_viii.rencana_jadwal_rilis_produk_tercetak && data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length>0) || 
                              (data.blok_viii.rencana_jadwal_rilis_produk_digital && data.blok_viii.rencana_jadwal_rilis_produk_digital.length>0) || 
                              (data.blok_viii.rencana_jadwal_rilis_produk_mikrodata && data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length>0)"
                        >
                      <div class="question__name">8.2. Rencana Rilis Produk Kegiatan</div>
                      <div class="question__value">
                        <div class="table-wrapper mt-2">
                          <table  class="table table--light table--bordered">
                            <thead>
                              <tr>
                                <th class="w-200 text-left">Jenis Produk</th>
                                <th class="text-center">Tanggal Rilis</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td >Tercetak (Hardcopy)</td>
                                <td class="text-center">
                                  <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_tercetak" v-bind:key="index">
                                    {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length>1">,</span>
                                    
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td >Digital (Softcopy)</td>
                                <td class="text-center">
                                  <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_digital" v-bind:key="index">
                                    {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_digital.length>1">,</span>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td >Data Mikro</td>
                                <td class="text-center">
                                  <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_mikrodata" v-bind:key="index">
                                    {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length>1">,</span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                
              </div>
            </b-col>
            <b-col id="review" cols="4" sm="4" md="4" lg="4" xl="3" class="pr-0 mr-0" v-if="isReviewVisible">
            <div class="sidebar-cards-wrapper" style="position: sticky; top: 157px; max-height: calc(100vh - 175px); overflow-y: auto; padding-right: 2px;">
              
              <!-- CARD 1: Catatan Pemeriksaan -->
              <div class="review my-0 mx-0 mb-3" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;" v-if="(form && form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)"> 
                <div class="review__header" style="cursor: pointer;" @click="isReviewCardOpen = !isReviewCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Catatan Pemeriksaan
                    <span v-if="(form && form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                      {{ (form && form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button mr-1" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isReviewCardOpen = !isReviewCardOpen"
                      :title="isReviewCardOpen ? 'Sembunyikan Catatan Pemeriksaan' : 'Tampilkan Catatan Pemeriksaan'"
                    >
                      <VueFeather :type="isReviewCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                    <button class="button" variant="icon" size="sm" @click.stop="isReviewOpen = false" title="Tutup Panel">
                      <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isReviewCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px;">
                    <div style="margin-bottom:20px;" v-if="form && form.reviews && form.reviews.length>0" >
                        <div v-for="(reviewItem, reviewIndex) in form.reviews" :key="reviewIndex" class="review-item d-block">
                          <div class="d-flex">
                              <div class="review-item__number">{{reviewIndex+1}}.</div>
                              <div class="review-item__note">
                                <span class="review-item__field" v-if="reviewItem.field">
                                  #{{ getReviewFieldLabel(reviewItem.field) }} : 
                                </span>
                                {{reviewItem.note}}
                              </div>
                          </div>
                          <div class="d-flex align-items-center review-item__info pt-1 mb-1" style="padding-left:19px">
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-if="reviewItem.created_at">{{reviewItem.created_at | formatDate}}</div>
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-else-if="msKeg">{{msKeg.created_at | formatDate}}</div>
                          </div>
                        </div>
                    </div>
                    <div class="history-review" v-if="msKeg && reviewHistories && reviewHistories.length>0" >
                        <div class="text-bold text-primary" style="margin:5px 11px">History Pemeriksaan:</div>
                        <div class="mt-1">
                          <div v-for="(reviewItem, reviewIndex) in reviewHistories" :key="reviewIndex" class="review-item d-block">
                              <div class="d-flex">
                                  <div class="review-item__number">{{reviewIndex+1}}.</div>
                                  <div class="review-item__note">
                                    <span class="review-item__field" v-if="reviewItem.field">
                                      #{{ getReviewFieldLabel(reviewItem.field) }} : 
                                    </span>
                                    {{reviewItem.note}}
                                  </div>
                              </div>
                              <div class="d-flex align-items-center review-item__info pt-1" style="padding-left:19px" v-if="reviewItem.created_at">
                                  <div class="text-10 text-500 mr-2" style="line-height:1">{{reviewItem.created_at | formatDate}}</div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- CARD 2: Histori Status -->
              <div class="review my-0 mx-0" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;" v-if="msKeg && msKegHistories && msKegHistories.length>0">
                <div class="review__header" style="cursor: pointer;" @click="isHistoryStatusCardOpen = !isHistoryStatusCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="clock" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Histori Status
                    <span class="badge badge-light ml-1 text-primary">
                      {{ msKegHistories.length }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isHistoryStatusCardOpen = !isHistoryStatusCardOpen"
                      :title="isHistoryStatusCardOpen ? 'Sembunyikan Histori Status' : 'Tampilkan Histori Status'"
                    >
                      <VueFeather :type="isHistoryStatusCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isHistoryStatusCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px; padding: 10px 12px;">
                    <div class="history-status mt-0" style="margin: 0px 0px;">
                      <div v-for="(history, historyIndex) in msKegHistories" :key="historyIndex" class="history-status__item">
                          <div class="d-flex align-items-center">
                              <div class="history-status__number">{{historyIndex+1}}.</div>
                              <div :class="'history-status__badge history-status__badge--'+ statusFormatterStyle(history.status)">
                                  {{statusFormatter(history.status)}}
                              </div>
                              <div class="text-10 text-500 ml-auto" v-if="history.created_at" style="line-height:1">
                                  {{history.created_at | formatDate}}
                              </div>
                          </div>
                          <div class="history-status__info" v-if="history.created_by && history.created_by.organization && history.created_by.organization.name">
                              <span>{{history.created_by.organization.name}}</span>
                          </div>
                          <div class="history-status__rejection" v-if="history.status == 'REJECTED' && history.rejection_note">
                              <strong>Catatan Penolakan:</strong> {{history.rejection_note}}
                          </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

            </div>
          </b-col>
          </b-row>
        </b-tab>
        <b-tab>
          <div class="d-flex flex-wrap justify-content-between align-items-center mt-3 mb-2">
            <div class="d-flex align-items-center mb-2 mb-md-0">
              <span class="mr-2 text-13 text-secondary font-weight-500">Tampilkan:</span>
              <b-form-select
                v-model="msVar.page_size"
                :options="pageOptions"
                size="sm"
                style="width: 85px;"
                @change="msVar.current_page = 1"
              ></b-form-select>
              <span class="ml-2 text-13 text-muted">
                (Menampilkan {{ filteredMsVarItems.length ? ((msVar.page_size > 0 ? (msVar.current_page - 1) * msVar.page_size + 1 : 1) + ' - ' + (msVar.page_size > 0 ? Math.min(msVar.current_page * msVar.page_size, filteredMsVarItems.length) : filteredMsVarItems.length)) : 0 }} dari {{ filteredMsVarItems.length }} variabel)
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="table-search m-0 p-1" style="max-width: 350px; width: 100%;">
                <b-input-group size="sm">
                  <b-input-group-prepend is-text class="bg-none">
                    <VueFeather type="search" size="14" stroke-width="2.5" stroke="#919191"></VueFeather>
                  </b-input-group-prepend>
                  <b-form-input 
                    type="search"
                    debounce="300"
                    v-model="msVar.filter" 
                    placeholder="Cari nama variabel..." 
                    class="border-left-0"
                    @input="msVar.current_page = 1"
                  ></b-form-input>
                <b-input-group-append v-if="msVar.filter">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="msVar.filter = ''; msVar.current_page = 1">
                    <VueFeather type="x" size="12"></VueFeather>
                  </button>
                </b-input-group-append>
              </b-input-group>
            </div>
            </div>
          </div>
          <div class="table-wrapper mt-2">
            <b-table
                class="table--light"
                show-empty
                :items="filteredMsVarItems"
                :fields="msVar.fields"
                :per-page="msVar.page_size > 0 ? msVar.page_size : 0"
                :current-page="msVar.current_page"
            >
                <template #cell(no)="data">
                  {{ msVar.page_size > 0 ? (msVar.current_page - 1) * msVar.page_size + data.index + 1 : data.index + 1 }}
                </template>
                <template #cell(alias)="data">
                  {{data.item.data.alias}}
                </template>
                <template #cell(sds)="data">
                  {{data.item.data.id_sds ? 'Ya' : 'Tidak'}}
                </template>
                <template #head(alias)="data">
                  <div class="d-flex align-items-center">
                    <div>{{data.label}}</div>
                    <div class="ml-1">
                      <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == null" @click="sortMsVariableBy(0)">
                          <b-icon icon="chevron-expand"></b-icon>
                      </b-button>
                      <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == 'asc'"  @click="sortMsVariableBy(0)">
                          <b-icon icon="sort-alpha-up"></b-icon>
                      </b-button>
                      <b-button  type="button"  class="button button--action" v-show="sortBy[0].direction == 'desc'" @click="sortMsVariableBy(0)">
                          <b-icon icon="sort-alpha-down"></b-icon>
                      </b-button>
                    </div>
                  </div>
                </template>
                <template #cell(created_at)="data">
                  {{data.value | formatDate}}
                </template>
                <template #cell(created_by)="data">
                  {{data.item.requester_details ? data.item.requester_details.name : data.item.requested_by}}
                </template>
                <template #cell(status)="data">
                  <div :class="'status status--'+ statusFormatterStyle(data.value)">
                    {{statusFormatter(data.value)}}
                  </div>
                </template>
                <template #cell(aksi)="data">
                  <div class="d-flex justify-content-center">
                    <b-link  
                      class="button button--action button--action--view " 
                      v-b-tooltip.hover.bottom title="Lihat detail"
                      :to="'/metadata/view-variabel/'+data.item.id"
                    >
                      <VueFeather type="eye" size="14"></VueFeather>
                    </b-link>
                    <b-link  class="button button--action button--action--edit " 
                      v-b-tooltip.hover.bottom
                      :title="!editable(data.item) ? 'Anda hanya bisa mengedit Kegiatan yang berstatus Draft atau Perlu Perbaikan ':'Edit'"  
                      :disabled="!editable(data.item)"
                      :to="'/metadata/update-variabel/'+data.item.id" 
                    >
                      <VueFeather type="edit-3" size="14"></VueFeather>
                    </b-link>
                    <b-link  class="button button--action button--action--delete" 
                      v-b-tooltip.hover.bottom 
                      :title="!isCreatedByMe(data.item) ? 'Anda tidak bisa menghapus data operator lain':'Hapus'"  
                      :disabled="!isCreatedByMe(data.item)"
                      v-on:click="()=>{deletedMsVarId = data.item.id;$bvModal.show('modal-delete-msvar-msind');}" >
                      <VueFeather type="x" size="14"></VueFeather>
                    </b-link>
                  </div>
                </template>
                <template #empty>
                  <div class="table__empty">
                      <div v-if="msVar.isLoading">
                        <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                      <div v-else>
                        <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                        <span v-if="msVar.filter">Tidak ada variabel dengan pencarian "{{ msVar.filter }}"</span>
                        <span v-else>Tidak ada data yang tersedia</span>
                      </div>
                  </div>
                </template> 
            </b-table>
            <div class="pagination-wrapper" v-if="msVar.page_size > 0 && filteredMsVarItems.length > msVar.page_size">
              <b-pagination
                class="mt-3"
                align="center"
                v-model="msVar.current_page"
                :total-rows="filteredMsVarItems.length"
                :per-page="msVar.page_size"
              ></b-pagination>
              <div class="pagination__goto ml-auto">Go to Page &nbsp;&nbsp;
                <b-form-input type="number" debounce="300" size="sm" v-model="msVar.current_page" :min="1" :max="Math.ceil(filteredMsVarItems.length / msVar.page_size)"></b-form-input>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <div class="d-flex flex-wrap justify-content-between align-items-center mt-3 mb-2">
            <div class="d-flex align-items-center mb-2 mb-md-0">
              <span class="mr-2 text-13 text-secondary font-weight-500">Tampilkan:</span>
              <b-form-select
                v-model="msInd.page_size"
                :options="pageOptions"
                size="sm"
                style="width: 85px;"
                @change="msInd.current_page = 1"
              ></b-form-select>
              <span class="ml-2 text-13 text-muted">
                (Menampilkan {{ filteredMsIndItems.length ? ((msInd.page_size > 0 ? (msInd.current_page - 1) * msInd.page_size + 1 : 1) + ' - ' + (msInd.page_size > 0 ? Math.min(msInd.current_page * msInd.page_size, filteredMsIndItems.length) : filteredMsIndItems.length)) : 0 }} dari {{ filteredMsIndItems.length }} indikator)
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="table-search m-0 p-1" style="max-width: 350px; width: 100%;">
                <b-input-group size="sm">
                  <b-input-group-prepend is-text class="bg-none">
                    <VueFeather type="search" size="14" stroke-width="2.5" stroke="#919191"></VueFeather>
                  </b-input-group-prepend>
                  <b-form-input 
                    type="search"
                    debounce="300"
                    v-model="msInd.filter" 
                    placeholder="Cari nama indikator..." 
                    class="border-left-0"
                    @input="msInd.current_page = 1"
                  ></b-form-input>
                <b-input-group-append v-if="msInd.filter">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="msInd.filter = ''; msInd.current_page = 1">
                    <VueFeather type="x" size="12"></VueFeather>
                  </button>
                </b-input-group-append>
              </b-input-group>
            </div>
            </div>
          </div>
          <div class="table-wrapper mt-2">
            <b-table
                class="table--light"
                show-empty
                :items="filteredMsIndItems"
                :fields="msInd.fields"
                :per-page="msInd.page_size > 0 ? msInd.page_size : 0"
                :current-page="msInd.current_page"
            >
                <template #cell(no)="data">
                  {{ msInd.page_size > 0 ? (msInd.current_page - 1) * msInd.page_size + data.index + 1 : data.index + 1 }}
                </template>
                <template #cell(created_at)="data">
                  {{data.value | formatDate}}
                </template>
                 <template #cell(sds)="data">
                  {{data.item.data.id_sds ? 'Ya' : 'Tidak'}}
                </template>
                <template #cell(created_by)="data">
                  {{data.item.requester_details ? data.item.requester_details.name : data.item.requested_by}}
                </template>
                <template #cell(status)="data">
                  <div :class="'status status--'+ statusFormatterStyle(data.value)">
                    {{statusFormatter(data.value)}}
                  </div>
                </template>
                <template #cell(aksi)="data">
                  <div class="d-flex justify-content-center">
                    <b-link  
                      class="button button--action button--action--view " v-b-tooltip.hover.bottom title="Lihat detail"
                      :to="'/metadata/view-indikator/'+data.item.id"
                    >
                      <VueFeather type="eye" size="14"></VueFeather>
                    </b-link>
                    <b-link  class="button button--action button--action--edit " 
                      v-b-tooltip.hover.bottom
                      :title="!editable(data.item) ? 'Anda hanya bisa mengedit Kegiatan yang berstatus Draft atau Perlu Perbaikan ':'Edit'"  
                      :disabled="!editable(data.item)"
                      :to="'/metadata/update-indikator/'+data.item.id" 
                    >
                      <VueFeather type="edit-3" size="14"></VueFeather>
                    </b-link>
                    <b-link  class="button button--action button--action--delete" 
                      v-b-tooltip.hover.bottom
                      :title="!isCreatedByMe(data.item) ? 'Anda tidak bisa menghapus data operator lain':'Hapus'"  
                      :disabled="!isCreatedByMe(data.item)"
                      v-on:click="()=>{deletedMsIndId = data.item.id;$bvModal.show('modal-delete-msvar-msind');}" >
                      <VueFeather type="x" size="14"></VueFeather>
                    </b-link>
                  </div>
                </template>
                <template #empty>
                  <div class="table__empty">
                      <div v-if="msInd.isLoading">
                        <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                      <div v-else>
                        <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                        <span v-if="msInd.filter">Tidak ada indikator dengan pencarian "{{ msInd.filter }}"</span>
                        <span v-else>Tidak ada data yang tersedia</span>
                      </div>
                  </div>
                </template> 
            </b-table>
            <div class="pagination-wrapper" v-if="msInd.page_size > 0 && filteredMsIndItems.length > msInd.page_size">
              <b-pagination
                class="mt-3"
                align="center"
                v-model="msInd.current_page"
                :total-rows="filteredMsIndItems.length"
                :per-page="msInd.page_size"
              ></b-pagination>
              <div class="pagination__goto ml-auto">Go to Page &nbsp;&nbsp;
                <b-form-input type="number" debounce="300" size="sm" v-model="msInd.current_page" :min="1" :max="Math.ceil(filteredMsIndItems.length / msInd.page_size)"></b-form-input>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      
    </div>

    <b-modal  hide-header hide-footer id="modal-delete-msvar-msind" size="sm" content-class="p-0 modal modal--confirmation text-center" >
      <div class="px-2 pb-3 pt-0 mx-3 mt-0 my-2" style="border-radius:3px">
        <div >
          <img src="@/assets/img/delete.svg" width="200" height="200" />
        </div>
        <div class="text-center text-14 text-semi-bold" style="margin-top:-20px">
          Apakah anda yakin menghapus item ini?
        </div>
        <div class="text-12 text-700">
          Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
        </div>
        <div class="mt-4 mb-1 d-flex justify-content-center">
          <b-button class="button button--outlined mr-2" v-on:click="()=>{$bvModal.hide('modal-delete');}">Batal</b-button>
          <b-button class="button button--danger" @click="deleteMsVar" v-if="tab.index==1">Hapus</b-button>
          <b-button class="button button--danger" @click="deleteMsInd" v-if="tab.index==2">Hapus</b-button>
        </div>
      </div>
      
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-loading"  content-class="modal modal--confirmation text-center p-2" centered dialog-class="d-flex justify-content-center">
        <div class="text-center px-3 py-4">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses penghapusan sedang berlangsung
          </div>
        </div>
      </b-modal>

    <!-- Modal Sync Metadata (Variabel / Indikator) dari old_id -->
    <b-modal
      id="modal-sync-metadata"
      size="lg"
      no-close-on-backdrop
      :no-close-on-esc="syncState.isSyncing"
      :hide-header-close="syncState.isSyncing"
      content-class="modal-sync"
    >
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center justify-content-between w-100 px-3 py-1">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center justify-content-center mr-2 rounded-circle" style="width: 32px; height: 32px; background: #e0f2f1; color: #00796b;">
              <VueFeather type="refresh-cw" size="16" stroke-width="2.5" :class="{'fa-spin': syncState.isSyncing}"></VueFeather>
            </div>
            <div>
              <h5 class="m-0 font-weight-bold text-15 text-dark" style="line-height: 1.2;">
                Sync Metadata {{ syncState.type === 'variabel' ? 'Variabel' : 'Indikator' }}
              </h5>
              <div class="text-11 text-muted">
                Salin metadata dari kegiatan siklus sebelumnya ke status DRAFT
              </div>
            </div>
          </div>
          <button v-if="!syncState.isSyncing" type="button" class="close" @click="close" style="outline: none; margin-top: -6px;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <!-- MODAL BODY WRAPPER DENGAN PADDING HORIZONTAL & VERTIKAL YANG RAPI -->
      <div class="px-4 py-3">
        <!-- STEP LOADING -->
        <div v-if="syncState.step === 'loading'" class="py-5 text-center">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
          <div class="mt-3 text-14 font-weight-bold text-dark">
            Mengambil data kegiatan sumber (ID: {{ targetOldKegId }})...
          </div>
          <div class="text-12 text-muted mt-1">
            Mohon tunggu sebentar selagi sistem memuat metadata siklus sebelumnya.
          </div>
        </div>

        <!-- STEP ERROR -->
        <div v-else-if="syncState.step === 'error'" class="py-4 text-center">
          <VueFeather type="alert-circle" size="48" class="text-danger mb-2"></VueFeather>
          <div class="text-15 font-weight-bold text-danger">Gagal Menyiapkan Sinkronisasi</div>
          <div class="text-13 text-secondary mt-1 px-3">{{ syncState.errorMsg }}</div>
        </div>

        <!-- STEP PREVIEW -->
        <div v-else-if="syncState.step === 'preview'">
          <div class="p-3 mb-3 d-flex align-items-start" style="background: #e8f5e9; border: 1px solid #c8e6c9; border-radius: 6px;">
            <div class="mr-2 text-success mt-1">
              <VueFeather type="info" size="18" stroke-width="2.5"></VueFeather>
            </div>
            <div class="text-12" style="color: #1b5e20; line-height: 1.5;">
              Fitur ini menyinkronkan metadata <strong>{{ syncState.type === 'variabel' ? 'Variabel' : 'Indikator' }}</strong> dari kegiatan siklus sebelumnya (ID: <strong>{{ targetOldKegId }}</strong>) ke kegiatan ini. Semua item hasil sinkronisasi akan berstatus <strong>DRAFT</strong>.
            </div>
          </div>

          <div class="card mb-3 border" style="border-color: #e2e8f0; border-radius: 6px; background: #f8fafc;">
            <div class="card-body p-3">
              <div class="d-flex align-items-center mb-2">
                <VueFeather type="archive" size="13" class="text-secondary mr-1"></VueFeather>
                <span class="text-11 font-weight-bold text-muted text-uppercase" style="letter-spacing: 0.5px;">Kegiatan Sumber (Siklus Sebelumnya)</span>
              </div>
              <div class="row text-12">
                <div class="col-sm-3 text-muted font-weight-500">Judul Kegiatan:</div>
                <div class="col-sm-9 font-weight-600 text-dark">
                  {{ syncState.sourceKeg ? (syncState.sourceKeg.data ? (syncState.sourceKeg.data.judul_kegiatan || syncState.sourceKeg.data.judulKegiatan) : syncState.sourceKeg.name) : '-' }}
                </div>
                <div class="col-sm-3 text-muted font-weight-500 mt-2">ID Kegiatan:</div>
                <div class="col-sm-3 font-weight-600 text-dark mt-2">
                  <span class="badge badge-secondary px-2 py-1">ID {{ targetOldKegId }}</span>
                </div>
                <div class="col-sm-3 text-muted font-weight-500 mt-2">Tahun / Periode:</div>
                <div class="col-sm-3 font-weight-600 text-dark mt-2">
                  {{ syncState.sourceKeg ? (syncState.sourceKeg.submission_period || syncState.sourceKeg.year) : '-' }}
                </div>
              </div>
            </div>
          </div>

          <div class="row text-center mb-3">
            <div class="col-4">
              <div class="p-3 rounded border" style="background: #ffffff; border-color: #e2e8f0;">
                <div class="text-11 font-weight-bold text-uppercase text-muted" style="letter-spacing: 0.5px;">Total di Sumber</div>
                <div class="text-22 font-weight-bold text-dark mt-1">{{ syncState.allItems.length }}</div>
                <div class="text-11 text-muted mt-1">{{ syncState.type === 'variabel' ? 'Variabel' : 'Indikator' }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="p-3 rounded border" style="background: #f0fdf4; border-color: #86efac;">
                <div class="text-11 font-weight-bold text-uppercase text-success" style="letter-spacing: 0.5px;">Sudah Ada di Sini</div>
                <div class="text-22 font-weight-bold text-success mt-1">{{ syncState.existingCount }}</div>
                <div class="text-11 text-muted mt-1">Tersimpan</div>
              </div>
            </div>
            <div class="col-4">
              <div class="p-3 rounded border" :style="syncState.missingItems.length > 0 ? 'background: #eff6ff; border-color: #93c5fd;' : 'background: #ffffff; border-color: #e2e8f0;'">
                <div class="text-11 font-weight-bold text-uppercase" :class="syncState.missingItems.length > 0 ? 'text-primary' : 'text-muted'" style="letter-spacing: 0.5px;">Belum Ada (Baru)</div>
                <div class="text-22 font-weight-bold mt-1" :class="syncState.missingItems.length > 0 ? 'text-primary' : 'text-muted'">{{ syncState.missingItems.length }}</div>
                <div class="text-11 text-muted mt-1">Akan Disinkronkan</div>
              </div>
            </div>
          </div>

          <div class="p-3 mb-3 rounded border" style="background: #fafafa; border-color: #e5e7eb;">
            <b-form-checkbox v-model="syncState.onlyMissing" @change="updateItemsToProcess">
              <span class="text-13 font-weight-bold text-dark">
                Hanya sinkronkan item yang <u>belum ada</u> di kegiatan saat ini (Dianjurkan)
              </span>
            </b-form-checkbox>
            <div class="text-11 text-muted ml-4 mt-1" style="line-height: 1.4;">
              Mencegah duplikasi data bagi metadata yang sebelumnya sudah berhasil tercopy.
            </div>
          </div>

          <div v-if="syncState.itemsToProcess.length === 0" class="p-3 rounded border d-flex align-items-center" style="background: #fffbeb; border-color: #fde68a;">
            <VueFeather type="check-circle" size="16" class="text-warning mr-2 flex-shrink-0"></VueFeather>
            <div class="text-12 text-dark font-weight-500">
              Semua {{ syncState.type }} dari kegiatan sumber sudah ada pada kegiatan ini. Tidak ada data baru yang perlu disinkronkan.
            </div>
          </div>
        </div>

        <!-- STEP PROCESSING & DONE -->
        <div v-else-if="syncState.step === 'processing' || syncState.step === 'done'">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center">
              <VueFeather type="terminal" size="14" class="text-secondary mr-1"></VueFeather>
              <span class="text-13 font-weight-bold text-dark">
                Progress Sinkronisasi {{ syncState.type === 'variabel' ? 'Variabel' : 'Indikator' }}
              </span>
            </div>
            <div class="text-12 font-weight-bold">
              <span v-if="syncState.step === 'processing'" class="text-primary d-flex align-items-center">
                <b-spinner small class="mr-1"></b-spinner>
                Memproses ({{ syncState.progress.done + syncState.progress.failed }} / {{ syncState.progress.total }})
              </span>
              <span v-else-if="syncState.step === 'done'" class="text-success font-weight-bold">
                <VueFeather type="check-circle" size="13" class="mr-1 text-success"></VueFeather> Selesai
              </span>
            </div>
          </div>

          <!-- Progress bar -->
          <b-progress 
            :value="syncState.progress.done + syncState.progress.failed" 
            :max="syncState.progress.total || 1" 
            height="6px" 
            variant="primary" 
            animated 
            class="mb-3"
          ></b-progress>

          <!-- Terminal log box -->
          <div 
            id="sync-console-log" 
            style="background:#1e1e1e;color:#ddd;border-radius:6px;padding:12px;max-height:260px;overflow-y:auto;font-family:monospace;font-size:11.5px;line-height:1.6;"
          >
            <div v-for="(log, idx) in syncState.logs" :key="idx" v-html="log"></div>
          </div>

          <div class="mt-3 d-flex justify-content-between align-items-center">
            <div class="text-12">
              <span class="badge badge-success px-2 py-1 mr-2" style="font-size: 11px;">
                Berhasil: {{ syncState.progress.done }}
              </span>
              <span v-if="syncState.progress.failed > 0" class="badge badge-danger px-2 py-1" style="font-size: 11px;">
                Gagal: {{ syncState.progress.failed }}
              </span>
            </div>
            <div v-if="syncState.step === 'done'" class="text-12 text-muted">
              Status: Semua item berhasil disinkronkan menjadi <strong>DRAFT</strong>.
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER BUTTONS -->
      <template #modal-footer>
        <template v-if="syncState.step === 'preview'">
          <b-button class="button button--outlined button--sm mr-2" @click="closeSyncModal">Batal</b-button>
          <b-button
            class="button button--primary button--sm"
            :disabled="syncState.itemsToProcess.length === 0"
            @click="executeSync"
          >
            <VueFeather type="play" size="13" class="mr-1"></VueFeather>
            Mulai Sinkronisasi ({{ syncState.itemsToProcess.length }} item)
          </b-button>
        </template>
        <template v-else-if="syncState.step === 'processing'">
          <b-button class="button button--outlined button--sm" disabled>
            <b-spinner small class="mr-1"></b-spinner> Sedang Menyimpan...
          </b-button>
        </template>
        <template v-else-if="syncState.step === 'done'">
          <b-button class="button button--primary button--sm" @click="closeSyncModal">
            Selesai &amp; Tutup
          </b-button>
        </template>
        <template v-else-if="syncState.step === 'error'">
          <b-button class="button button--outlined button--sm" @click="closeSyncModal">Tutup</b-button>
        </template>
      </template>
    </b-modal>

  </div> 
  
</template>
<script>
import "@/assets/scss/main.scss";
import MsService from "../../../services/MsService";
import master from "./Master.js";
import VueFeather from 'vue-feather';
import store from "../../../store";
import moment from "moment";
import lodash from "lodash";
import * as role from "../SdiRole";
import Breadcrumbs from "@/components/Breadcrumbs";
import { flatReviewFields } from "../reviewKegFields";
export default {
  name: "MetadataDetail",
  components: {
    VueFeather,
    Breadcrumbs
  },  
  data: () => ({
    breadcrumbs:[
        {
          text:'Beranda',
          href:'/',
        },
        {
          text:'Daftar Usulan MS-Keg',
          href:'/metadata/summary',
        },
        {
          text:'Detail MS-Keg',
          href:'',
          active:true,
        }
    ],
    deletedMsVarId:null,
    deletedMsIndId:null,
    isLoading:false,
    tab:{
      index:0,
      items:[
          {
            name:'Metadata Statistik Kegiatan',
            count : 1,
          },
          {
            name:'Metadata Statistik Variabel',
            count : 0,
          },
          {
            name:'Metadata Statistik Indikator',
            count : 0,
          },
      ]
    },
    masters: null,
    form: [],
    data: {
      judul_kegiatan: null,
      tahun: new Date().getFullYear(),
      jenis_statistik:"STATISTIK_DASAR",
      cara_pengumpulan_data: null,
      sektor_kegiatan: null,
      identitas_rekomendasi: 'K-21.5105.001',
      blok_i: {
        instansi_penyelanggara: null,
        alamat_instansi_penyelenggara: {
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_ii: {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null
        },
        penanggung_jawab_teknis: {
          nama: null,
          jabatan: null,
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null
        }
      },
      blok_iii: {
        latar_belakang_kegiatan: null,
        tujuan_kegiatan: null,
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          desain: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          pengumpulan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          pengolahan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          analisis: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          diseminasi_hasil: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ],
          evaluasi: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01"
            }
          ]
        },
        variabel_yang_dikumpulkan: [
          {
            nama: null,
            konsep: null,
            definisi: null,
            referensi_waktu: null
          }
        ]
      },
      blok_iv: {
        kegiatan_ini_dilakukan: "HANYA_SEKALI",
        frekuensi_penyelanggara: "HARIAN",
        tipe_pengumpulan_data: "LONGITUDINAL_PANEL",
        cakupan_wilayah_pengumpulan_data: "SELURUH_WILAYAH_INDONESIA",
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: true,
          mengisi_kuesioner_sendiri: false,
          pengamatan: false,
          pengumpulan_data_sekunder: false,
          lainnya: false,
          metode_pengumpulan_lainnya: null
        },
        sarana_pengumpulan_data: {
          papi: true,
          capi: false,
          cati: false,
          cawi: false,
          mail: false,
          lainnya: false,
          sarana_pengumpulan_lainnya: null
        },
        unit_pengumpulan_data: {
          individu: true,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: false,
          unit_pengumpulan_data_lainnya: null
        }
      },
      blok_v: {
        jenis_rancangan_sampel: "SINGLE_STAGE_ATAU_PHASE",
        metode_pemilihan_sampel_tahap_terakhir: "SAMPEL_PROBABILITAS",
        metode_yang_digunakan: "SIMPLE_RANDOM_SAMPLING",
        kerangka_sampel_tahap_terakhir: "LIST_FRAME",
        fraksi_sampel_keseluruhan: null,
        nilai_perkiraan_sampling_error_variabel_utama: null,
        unit_sampel: null,
        unit_observasi: null
      },
      blok_vi: {
        apakah_melakukan_uji_coba: true,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: true,
          supervisi: false,
          taskforce: false,
          lainnya: false,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null
        },
        apakah_melakukan_penyesuaian_nonrespon: true,
        petugas_pengumpulan_data: "STAF_INSTANSI_PENYELENGGARA",
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data: "KURANG_DARI_ATAU_SAMA_DENGAN_SMP",
        jumlah_petugas_supervisor: 0,
        jumlah_petugas_enumerator: 0,
        apakah_melakukan_pelatihan_petugas: true
      },
      blok_vii: {
        tahapan_pengolahan_data: {
          editing: true,
          coding: false,
          data_entry: false,
          validasi: false
        },
        metode_analisis: "DESKRIPTIF",
        unit_analsis: {
          individu: true,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: false,
          unit_analisis_lainnya: null
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: true,
          provinsi: false,
          kabupaten_atau_kota: false,
          kecamatan: false,
          lainnya: false,
          tingkat_penyajian_hasil_analisis_lainnya: null
        }
      },
      blok_viii: {
        ketersediaan_produk_tercetak: false,
        ketersediaan_produk_digital: false,
        ketersediaan_produk_mikrodata: false,
        rencana_jadwal_rilis_produk_tercetak: [],
        rencana_jadwal_rilis_produk_digital: [],
        rencana_jadwal_rilis_produk_mikrodata: []
      }
    },
    msKeg:null,
    status: null,
    created_at: null,
    created_by: null,
    notes: null,
    produk_kegiatan: { tercetak: null, digital: null, data_mikro: null },
    tercetak: {
      produk: "Tercetak (hardcopy)",
      tanggal_rencana_rilis_produk: ""
    },
    digital: {
      produk: "Digital (softcopy)",
      tanggal_rencana_rilis_produk: ""
    },
    data_mikro: {
      produk: "Data Mikro",
      tanggal_rencana_rilis_produk: ""
    },
    variabelFields: [
      {
        key: "no",
        label: "No",
        thStyle: { width: "50px" },
        tdClass: "text-center"
      },
      {
        key: "nama",
        label: "Nama Variabel (Karakteristik)",
        thStyle: { width: "150px" },
        thClass: "text-left"
      },
      { key: "konsep", label: "Konsep Variabel", thStyle: { width: "250px" } },
      {
        key: "definisi",
        label: "Definisi Variabel",
        thStyle: { width: "250px" },
        thClass: "text-left"
      },
      {
        key: "referensi_waktu",
        label: "Referensi Waktu (Periode Enumerasi)",
        thStyle: { width: "150px" },
        thClass: "text-left"
      }
    ],
    variabelItems: [],
    table:{
      wilayahFields: [
        {
          key: "no",
          label: "No",
          thStyle: { width: "50px" },
          tdClass: "text-center"
        },
        {
          key: "nama_provinsi",
          label: "Nama Provinsi"
        },
        {
          key: "nama_kabupaten_kota",
          label: "Kabupaten/Kota"
        }
      ],
    },
    wilayahItems: [],
    msVar:{
      form:{
        ms_keg_id: null,
        submission_period: null,
        data: {
          nama: null,
          alias: null,
          konsep: null,
          definisi: null,
          referensi_pemilihan: [
            null
          ],
          referensi_waktu: null,
          ukuran: null,
          satuan: null,
          tipe_data: null,
          value_domain: [
            {
              kode: null,
              nilai: null
            }
          ],
          aturan_validasi: [
            null
          ],
          kalimat_pertanyaan: null,
          apakah_variabel_bisa_diakses_umum: true,
          id_sds: 0
        },
        reviews: [],
        changes: [],
        status: "DRAFT",
        rejection_note: null,
        submitter: null,
        produsen_data: null,
        walidata_pusat: null,
        version: 'v2'
      },
      isUpdate:false,
      updatedId:null,
      isLoading:false,
      filter:null,
      filtered_items:[],
      items: [],
      fields: [
          {
            key: "no",
            label: "No.",
            tdClass: "text-center",
            thStyle: { width: "5px" }
          },
          
          {
            key: "data.nama",
            label: "Nama Variabel",
            thClass: "text-left w-300",
          },
          {
            key: "alias",
            label: "Alias",
            thClass: "text-left w-101",
            tdClass: "text-left"
          },
          {
            key: "sds",
            label: "Referensi SDS",
            class: "w-101 text-center",
          },
          
          {
            key: "produsen_data_name",
            label: "Produsen Data",
            thClass: "text-left w-150",
            tdClass: "text-left"
          },
          {
            key: "created_by",
            label: "Pelapor",
            thClass: "text-left w-150",
            tdClass: "text-left"
          },
          {
            key: "created_at",
            label: "Tanggal Diajukan",
            thClass: "text-left w-101",
            tdClass: "text-left"
          },
          {
            key: "status",
            label: "Status",
            class: "text-center text-nowrap"
          },
          {
            key: "aksi",
            label: "Aksi",
            thClass: "text-center w-70",
            tdClass: "text-center"
          }
      ],
      
    },
    msInd:{
      isLoading:false,
      filter:null,
      filtered_items:[],
      items: [],
      fields: [
          {
            key: "no",
            label: "No.",
            tdClass: "text-center",
            thStyle: { width: "5px" }
          },
          {
            key: "data.nama",
            label: "Nama Indikator",
            thClass: "text-left w-300",
          },
          {
            key: "sds",
            label: "Referensi SDS",
            class: "w-101 text-wrap text-center",
          },
          {
            key: "produsen_data_name",
            label: "Produsen Data",
            thClass: "text-left w-150",
            tdClass: "text-left"
          },
          {
            key: "created_by",
            label: "Pelapor",
            thClass: "text-left w-150",
            tdClass: "text-left"
          },
          {
            key: "created_at",
            label: "Tanggal Diajukan",
            thClass: "text-left w-101",
            tdClass: "text-left"
          },
          {
            key: "status",
            label: "Status",
            class: "text-center text-nowrap"
          },
          {
            key: "aksi",
            label: "Aksi",
            thClass: "text-center w-150",
            tdClass: "text-center"
          }
      ],
      page_size: 10,
      current_page:1,
      total_pages: null,
    },
    sortBy:[
        {
          property: "alias",
          direction: null
        },
      ],
    user:null,
    userRoles:[],
    pageOptions: [
      { value: 10, text: '10' },
      { value: 25, text: '25' },
      { value: 50, text: '50' },
      { value: 100, text: '100' },
      { value: 0, text: 'Semua' }
    ],
    options:{
      status:[
        { id: "DRAFT", label: "Draft" },
        { id: "SUBMITTED", label: "Submit" },
        { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
        { id: "REVISED", label: "Sudah Diperbaiki" },
        { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
        { id: "REJECTED", label: "Ditolak" },
        { id: "APPROVED", label: "Disetujui" },
        { id: "PUBLISHED", label: "Publis" }
      ]
    },
    isReviewOpen: true,
    isReviewCardOpen: true,
    isHistoryStatusCardOpen: true,
    flatReviewFields: flatReviewFields,
    syncState: {
      type: 'variabel',
      step: 'preview',
      isSyncing: false,
      onlyMissing: true,
      sourceKeg: null,
      allItems: [],
      missingItems: [],
      existingCount: 0,
      itemsToProcess: [],
      progress: { done: 0, failed: 0, total: 0 },
      logs: [],
      errorMsg: ''
    }
  }),
  inject: ['appData'],
  async mounted() {
    this.isLoading= true
    if(localStorage.MsEntryListTabIndex){
        this.tab.index = parseInt(localStorage.MsEntryListTabIndex);
    }
    this.masters = master;
    this.getUserInfo(store.getters["auth/user"])
    await this.getDetailMsKeg();
    this.isLoading= false

    
    
  },
  computed:{
    isReviewVisible() {
      if (!this.isReviewOpen) return false;
      return (
        (this.form && this.form.reviews && this.form.reviews.length > 0) ||
        (this.reviewHistories && this.reviewHistories.length > 0) ||
        (this.msKegHistories && this.msKegHistories.length > 0)
      );
    },
    targetOldKegId() {
      if (!this.msKeg) return null;
      return this.msKeg.old_id || this.msKeg.base_id || null;
    },
    canSync() {
      if (!this.msKeg) return false;
      const oldId = this.msKeg.old_id || this.msKeg.base_id;
      return oldId !== null && oldId !== undefined && String(oldId).trim() !== '';
    },
    filteredMsVarItems() {
      if (!this.msVar.items || !Array.isArray(this.msVar.items)) return [];
      if (!this.msVar.filter || !this.msVar.filter.trim()) {
        return this.msVar.items;
      }
      const search = this.msVar.filter.toLowerCase().trim();
      return this.msVar.items.filter(item => {
        const nama = item.data && item.data.nama ? String(item.data.nama).toLowerCase() : '';
        const alias = item.data && item.data.alias ? String(item.data.alias).toLowerCase() : '';
        return nama.includes(search) || alias.includes(search);
      });
    },
    filteredMsIndItems() {
      if (!this.msInd.items || !Array.isArray(this.msInd.items)) return [];
      if (!this.msInd.filter || !this.msInd.filter.trim()) {
        return this.msInd.items;
      }
      const search = this.msInd.filter.toLowerCase().trim();
      return this.msInd.items.filter(item => {
        const nama = item.data && item.data.nama ? String(item.data.nama).toLowerCase() : '';
        return nama.includes(search);
      });
    },
    isSuperAdmin(){
      return this.userRoles.includes("ROLE_SUPERADMIN");
    },
    isKegiatanDitolakAtauDisetujui(){
      const st = ((this.msKeg && this.msKeg.status) || (this.form && this.form.status) || '').toUpperCase();
      return st === 'REJECTED' || st === 'APPROVED' || st === 'PUBLISHED' || st.includes('REJECT') || st.includes('APPROV');
    },
    AddVariableVisible(){
      if(this.isKegiatanDitolakAtauDisetujui){
        return false;
      }
      if(this.tab.index==1 && this.msKeg && (role.isWalidata([this.appData.current_role]) || role.isProdusenData([this.appData.current_role]))){
        if(this.msKeg.requested_by == this.user.username){
          return true;
        }
        else if(this.msKeg.produsen_data_id == this.user.organization.id || this.msKeg.produsen_data_name == this.user.organization.name){
          return true;
        }
        else if(this.msKeg.requester_organization_id == this.user.organization.id){
          return true;
        }else{
          return false
        }
      }else{
        return false
      }
      
    },
    AddIndicatorVisible(){
      if(this.isKegiatanDitolakAtauDisetujui){
        return false;
      }
      if(this.tab.index==2 && this.msKeg && (role.isWalidata([this.appData.current_role]) || role.isProdusenData([this.appData.current_role]))){
        if(this.msKeg.requested_by == this.user.username){
          return true;
        }else if(this.msKeg.produsen_data_id == this.user.organization.id || this.msKeg.produsen_data_name == this.user.organization.name){
          return true;
        }
        else if(this.msKeg.requester_organization_id == this.user.organization.id){
          return true;
        }else{
          return false
        }
      }else{
        return false
      }
    },
    reviewHistories(){
      let msKeg = this.msKeg;
      let allReview = msKeg.ms_keg_histories.filter(x=> !x.active && x.reviews && x.reviews.length>0).map(x=>x.reviews).flat();
      allReview = lodash.uniqBy(allReview, 'note');
      let currentReviewNotes = msKeg.reviews ? msKeg.reviews.map(x=>x.note) : [];

      let showedReviews = [];
      allReview.forEach(x=>{
        if(!currentReviewNotes.includes(x.note)){
          showedReviews.push(x);
        }
      })
      return showedReviews;
    },
    /**
     * History perubahan STATUS dari MS-Keg, diurutkan dari yang terbaru.
     * Sumber: msKeg.ms_keg_histories (tiap item berisi status, created_at,
     * created_by, rejection_note, dll).
     * Item dengan active=true (status saat ini) tetap ditampilkan di atas
     * sebagai "Status Saat Ini", sedangkan sisanya adalah historis.
     */
    msKegHistories(){
      const msKeg = this.msKeg;
      if(!msKeg || !Array.isArray(msKeg.ms_keg_histories)){
        return [];
      }
      // Sort dari yang terbaru ke yang terlama
      return [...msKeg.ms_keg_histories].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      });
    }
  },
  methods: {
    getReviewFieldLabel(fieldKey) {
      if (!fieldKey) return '';
      const found = this.flatReviewFields.find(f => f.value === fieldKey);
      if (found) {
        return found.label;
      }
      return fieldKey.replace(/_/g, ' ');
    },
    async getDetailMsKeg() {
      await MsService.getMsKegById(this.$route.params.id).then(
        response => {    
          this.msKeg = response.data.result[0];
          let msKeg = response.data.result[0];
          console.log('msKeg', msKeg.ms_keg_histories);

          this.msVar.items = msKeg.ms_var.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
          this.tab.items[1].count = this.msVar.items.length;

          this.msInd.items = msKeg.ms_ind;
          this.tab.items[2].count = this.msInd.items.length;

          this.form = {
              base_id: this.baseId ? this.baseId : null,
              submission_period: msKeg.submission_period,
              data: null,
              reviews: msKeg.reviews,
              status: msKeg.status,
              rejection_note: msKeg.rejection_note,
              submitter: this.user,
              produsen_data: {
                id: msKeg.produsen_data_id,
                name: msKeg.produsen_data_name,
                province_code: msKeg.produsen_data_province_code,
                city_code: msKeg.produsen_data_city_code
              },
              walidata_pusat: {
                id: msKeg.walidata_pusat_id,
                name: msKeg.walidata_pusat_name
              },
              version: 'v2',
              changes: null,
          };
          this.data = msKeg.data;
          
          if(msKeg.version == 'v1'){
            let keg = msKeg.data;
            this.data = {
              judul_kegiatan:        keg.judulKegiatan,
              tahun:                 keg.tahun,
              jenis_statistik:       msKeg.statistic_type,
              cara_pengumpulan_data: keg.caraPengumpulanData,
              sektor_kegiatan:       keg.sektorKegiatan,
              identitas_rekomendasi: null,
              // blok_i: {
              //   instansi_penyelanggara: keg.blokI.instansiPenyelanggara,
              //   alamat_instansi_penyelenggara: {
              //     alamat:    keg.blokI.alamatLengkapInstansiPenyelenggara,
              //     telepon:   keg.blokI.telepon,
              //     email:     keg.blokI.email,
              //     faksimile: keg.blokI.faksimile
              //   }
              // },
              blok_i: {
                instansi_penyelanggara: null,
                alamat_instansi_penyelenggara: {
                  alamat:    null,
                  telepon:   null,
                  email:     null,
                  faksimile: null
                }
              },
              blok_ii: {
                unit_penanggung_jawab: {
                  eselon1: keg.blokII.unitPenanggungJawabEselon1,
                  eselon2: keg.blokII.unitPenanggungJawabEselon2
                },
                penanggung_jawab_teknis: {
                  nama:      keg.blokII.namaPenanggungJawabTeknis,
                  jabatan:   keg.blokII.jabatanPenanggungJawabTeknis,
                  alamat:    keg.blokII.alamatPenanggungJawabTeknis,
                  telepon:   keg.blokII.teleponPenanggungJawabTeknis,
                  email:     keg.blokII.emailPenanggungJawabTeknis,
                  faksimile: keg.blokII.faksimilePenanggungJawabTeknis
                }
              },
              blok_iii: {
                latar_belakang_kegiatan: keg.blokIII.latarBelakangKegiatan,
                tujuan_kegiatan:         keg.blokIII.tujuanKegiatan,
                rencana_jadwal_kegiatan: {
                  perencanaan_kegiatan: keg.blokIII.rencanaJadwalKegiatan.perencanaanKegiatan.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  desain:               keg.blokIII.rencanaJadwalKegiatan.desain.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  pengumpulan_data:     keg.blokIII.rencanaJadwalKegiatan.pengumpulanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  pengolahan_data:      keg.blokIII.rencanaJadwalKegiatan.pengolahanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  analisis:             keg.blokIII.rencanaJadwalKegiatan.analisis.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  diseminasi_hasil:     keg.blokIII.rencanaJadwalKegiatan.diseminasiHasil.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
                  evaluasi:             keg.blokIII.rencanaJadwalKegiatan.evaluasi.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')}))
                },
                variabel_yang_dikumpulkan: keg.blokIII.variabelYangDikumpulkan.map(x=>({
                  nama: x.nama,
                  konsep: x.konsep,
                  definisi: x.definisi,
                  referensi_waktu: x.referensiWaktu
                }))
              },
              blok_iv: {
                kegiatan_ini_dilakukan:                    keg.blokIV.kegiatanIniDilakukan,
                frekuensi_penyelanggara:                   keg.blokIV.frekuensiPenyelanggara,
                tipe_pengumpulan_data:                     keg.blokIV.tipePengumpulanData,
                cakupan_wilayah_pengumpulan_data:          keg.blokIV.cakupanWilayahPengumpulanData,
                sebagian_cakupan_wilayah_pengumpulan_data: keg.blokIV.cakupanWilayahPengumpulanData == 'SEBAGIAN_WILAYAH_INDONESIA' && keg.blokIV.sebagianCakupanWilayahPengumpulanData && keg.blokIV.sebagianCakupanWilayahPengumpulanData.length>0?  
                  keg.blokIV.sebagianCakupanWilayahPengumpulanData.map(x=>({
                    kode_provinsi: null,
                    nama_provinsi: x.provinsi,
                    kode_kabupaten_kota: null,
                    nama_kabupaten_kota: x.kabupatenKota
                  })) : [],
                metode_pengumpulan_data: {
                  wawancara:                  keg.blokIV.metodePengumpulanData.wawancara,
                  mengisi_kuesioner_sendiri:  keg.blokIV.metodePengumpulanData.mengisiKuesionerSendiri,
                  pengamatan:                 keg.blokIV.metodePengumpulanData.pengamatan,
                  pengumpulan_data_sekunder:  keg.blokIV.metodePengumpulanData.pengumpulanDataSekunder,
                  lainnya:                    keg.blokIV.metodePengumpulanData.lainnya,
                  metode_pengumpulan_lainnya: keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya ? keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya : null
                },
                sarana_pengumpulan_data: {
                  papi: keg.blokIV.saranaPengumpulanData.papi,
                  capi: keg.blokIV.saranaPengumpulanData.capi,
                  cati: keg.blokIV.saranaPengumpulanData.cati,
                  cawi: keg.blokIV.saranaPengumpulanData.cawi,
                  mail: keg.blokIV.saranaPengumpulanData.mail,
                  lainnya: keg.blokIV.saranaPengumpulanData.lainnya,
                  sarana_pengumpulan_lainnya: 
                    keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya ? keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya : null, 
                },
                unit_pengumpulan_data: {
                  individu:                      keg.blokIV.unitPengumpulanData.individu,
                  rumah_tangga:                  keg.blokIV.unitPengumpulanData.rumahTangga,
                  usaha_atau_perusahaan:         keg.blokIV.unitPengumpulanData.usahaAtauPerusahaan,
                  lainnya:                       keg.blokIV.unitPengumpulanData.lainnya,
                  unit_pengumpulan_data_lainnya: keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya ? keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya : null
                }
              },
              blok_v: {
                jenis_rancangan_sampel:                        keg.blokV.jenisRancanganSampel,
                metode_pemilihan_sampel_tahap_terakhir:        keg.blokV.metodePemilihanSampelTahapTerakhir,
                metode_yang_digunakan:                         keg.blokV.metodeYangdigunakan == 'MULTI_STAGE_SAMPLING' ? 'PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING' : keg.blokV.metodePemilihanSampelTahapTerakhir,
                kerangka_sampel_tahap_terakhir:                keg.blokV.kerangkaSampelTahapTerakhir,
                fraksi_sampel_keseluruhan:                     keg.blokV.fraksiSampelKeseluruhan,
                nilai_perkiraan_sampling_error_variabel_utama: keg.blokV.nilaiPerkiraanSamplingErrorVariabelUtama,
                unit_sampel:                                   keg.blokV.unitSampel,
                unit_observasi:                                keg.blokV.unitObservasi
              },
              blok_vi: {
                apakah_melakukan_uji_coba: keg.blokVI.apakahMelakukanUjiCoba,
                metode_pemeriksaan_kualitas_pengumpulan_data: {
                  kunjungan_kembali: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.kunjunganKembali,
                  supervisi:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.supervisi,
                  taskforce:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.taskforce,
                  lainnya:           keg.blokVI.metodePemeriksaanKualitasPengumpulanData.lainnya,
                  metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: 
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya ? keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya : null
                },
                apakah_melakukan_penyesuaian_nonrespon:                   keg.blokVI.apakahMelakukanPenyesuaianNonrespon,
                petugas_pengumpulan_data:                                 keg.blokVI.petugasPengumpulanData,
                persyaratan_pendidikan_terendah_petugas_pengumpulan_data: keg.blokVI.persyaratanPendidikanTerendahPetugasPengumpulanData,
                jumlah_petugas_supervisor:                                keg.blokVI.jumlahPetugasSupervisor,
                jumlah_petugas_enumerator:                                keg.blokVI.jumlahPetugasEnumerator,
                apakah_melakukan_pelatihan_petugas:                       keg.blokVI.apakahMelakukanPelatihanPetugas
              },
              blok_vii: {
                tahapan_pengolahan_data: {
                  editing:    keg.blokVII.tahapanPengolahanData.udi,
                  coding:     keg.blokVII.tahapanPengolahanData.udi,
                  data_entry: keg.blokVII.tahapanPengolahanData.udi,
                  validasi:   keg.blokVII.tahapanPengolahanData.udi
                },
                metode_analisis: keg.blokVII.metodeAnalisis,
                unit_analsis: {
                  individu:              keg.blokVII.unitAnalsis.individu,
                  rumah_tangga:          keg.blokVII.unitAnalsis.rumahTangga,
                  usaha_atau_perusahaan: keg.blokVII.unitAnalsis.usahaAtauPerusahaan,
                  lainnya:               keg.blokVII.unitAnalsis.lainnya,
                  unit_analisis_lainnya: keg.blokVII.unitAnalsis.unitAnalisisLainnya ? keg.blokVII.unitAnalsis.unitAnalisisLainnya : null
                },
                tingkat_penyajian_hasil_analisis: {
                  nasional:            keg.blokVII.tingkatPenyajianHasilAnalisis.nasional,
                  provinsi:            keg.blokVII.tingkatPenyajianHasilAnalisis.provinsi,
                  kabupaten_atau_kota: keg.blokVII.tingkatPenyajianHasilAnalisis.kabupatenAtauKota,
                  kecamatan:           keg.blokVII.tingkatPenyajianHasilAnalisis.kecamatan,
                  lainnya:             keg.blokVII.tingkatPenyajianHasilAnalisis.lainnya,
                  tingkat_penyajian_hasil_analisis_lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya ? keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya : null, 
                }
              },
              blok_viii: {
                ketersediaan_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak,
                ketersediaan_produk_digital: keg.blokVIII.ketersediaanProdukDigital,
                ketersediaan_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata,
                rencana_jadwal_rilis_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak ? keg.blokVIII.rencanaJadwalRilisProdukTercetak.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                rencana_jadwal_rilis_produk_digital: keg.blokVIII.ketersediaanProdukDigital ? keg.blokVIII.rencanaJadwalRilisProdukDigital.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
                rencana_jadwal_rilis_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata ? keg.blokVIII.rencanaJadwalRilisProdukMikrodata.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
              }
            };         
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    sortMsVariableBy(index){
      let field = this.sortBy[index].property;
      let order = this.sortBy[index].direction;
      let data = JSON.parse(JSON.stringify(this.msVar.items));

      if(order == null){  
        this.sortBy[index].direction = 'asc'
        this.msVar.items = lodash.orderBy(data, [function(x){return x.data[field]} , function(x){return new moment(x.updated_at)} ], ['asc', 'desc']); 
      }
      if(order =='asc'){
        this.sortBy[index].direction = 'desc'
        this.msVar.items = lodash.orderBy(data, [function(x){return x.data[field]}, function(x){return new moment(x.updated_at)} ], ['desc', 'desc']);  
      }
      if(order == 'desc'){
        this.sortBy[index].direction = null
        this.msVar.items = lodash.orderBy(data, [function(x){return new moment(x.updated_at)} ], ['desc']);  
      }

    },
    getBadge(type) {
      if (type === "DRAFT") {
        return '<span class="w-100 badge badge-dark">Draft walidata</span>';
      } else if (type === "APPROVED") {
        return '<span class="w-100 badge badge-success">Diterima pembina data</span>';
      } else if (type === "REVISED") {
        return '<span class="w-100 badge badge-info">Diperbaiki oleh walidata</span>';
      } else if (type === "REJECTED") {
        return '<span class="w-100 badge badge-danger">Ditolak oleh pembina data</span>';
      } else if (type === "UNDER_REVIEW") {
        return '<span class="w-100 badge badge-primary">Diperiksa oleh pembina data</span>';
      } else if (type === "CORRECTION_REQUIRED") {
        return '<span class="w-100 badge badge-warning">Perbaikan walidata dan pembina data</span>';
      } else if (type === "SUBMITTED") {
        return '<span class="w-100 badge badge-secondary">Submit oleh walidata</span>';
      }
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    statusFormatterStyle(status){
      return status ? status.toLowerCase().replace('_','-') : 'draft';
    },
    statusFormatter(status){
      return status ? this.options.status.find(x=>x.id == status).label : 'Draft';
    },
    isCreatedByMe(item){
      if(item.requested_by == this.$store.getters['auth/user'].username || role.isSuperAdmin(this.userRoles)){
        return true;
      }else{
        return false;
      }
    },
    editable(item){
      if(role.isSuperAdmin(this.userRoles)){
        return true;
      }else{
        if(item.status == 'DRAFT' || item.status == 'CORRECTION_REQUIRED'){
          if(item.requested_by == this.user.username){
            return true;
          }
          else if(item.produsen_data_id == this.user.organization.id || item.produsen_data_name == this.user.organization.name){
            return true;
          }
          else if(item.requester_organization_id == this.user.organization.id){
            return true;
          }else if(role.isWalidata([this.current_role])){
            return true
          }
          else{
            return false;
          }
        }else{
          return false
        }
      }
    },
    deleteable(item){
      if(role.isSuperAdmin(this.userRoles)){
        return true;
      }else{
        if(item.status == 'DRAFT' && item.requested_by == this.$store.getters['auth/user'].username){
          return true
        }else{
          return false
        }
      }
    },
    getUserInfo(user){
      this.user = {
        name : user.name,
        username: user.username,
        email: user.email,
        division: null,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      },
      this.userRoles = user.role.slice(1,-1).split(", ");
    },
    tabIndexChanged(index){
      this.tab.index = index;
      localStorage.MsEntryListTabIndex = index;
    },
    saveMsVar(){

    },
    saveMsInd(){

    },
    async deleteMsVar() {
      this.$bvModal.hide('modal-delete-msvar-msind');
      this.$bvModal.show('modal-loading');
      await MsService.deleteMsVargById(this.deletedMsVarId).then(
        (result) => {
          this.$bvModal.hide('modal-loading');
          let response = result.data.result[0];
          if(response==null){
            this.getDetailMsKeg();
          }
          else{
            if(response.status == 403){
              this.modal.error.title = 'Delete Item Gagal';
              this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.show('modal-error');
          }
        },
        (error) => {
            console.log(error);
        }
      );
    },
    async deleteMsInd() {
      this.$bvModal.hide('modal-delete-msvar-msind');
      this.$bvModal.show('modal-loading');
      await MsService.deleteMsIndById(this.deletedMsIndId).then(
        (result) => {
          this.$bvModal.hide('modal-loading');
          let response = result.data.result[0];
          if(response==null){
            this.getDetailMsKeg();
          }
          else{
            if(response.status == 403){
              this.modal.error.title = 'Delete Item Gagal';
              this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.show('modal-error');
          }
        },
        (error) => {
            console.log(error);
        }
      );
    },
    async openSyncModal(type) {
      this.syncState.type = type;
      this.syncState.step = 'loading';
      this.syncState.logs = [];
      this.syncState.progress = { done: 0, failed: 0, total: 0 };
      this.syncState.onlyMissing = true;
      this.syncState.sourceKeg = null;
      this.syncState.errorMsg = '';
      this.$bvModal.show('modal-sync-metadata');

      const sourceId = this.targetOldKegId;
      if (!sourceId) {
        this.syncState.step = 'error';
        this.syncState.errorMsg = 'Kegiatan ini tidak memiliki referensi old_id kegiatan sebelumnya.';
        return;
      }

      try {
        const res = await MsService.getMsKegById(sourceId);
        const sourceKeg = res?.data?.result?.[0];
        if (!sourceKeg) {
          this.syncState.step = 'error';
          this.syncState.errorMsg = `Data kegiatan sumber dengan ID ${sourceId} tidak ditemukan.`;
          return;
        }
        this.syncState.sourceKeg = sourceKeg;
        this.calculateItemsToSync();
        this.syncState.step = 'preview';
      } catch (err) {
        console.error('Failed to get source kegiatan:', err);
        this.syncState.step = 'error';
        this.syncState.errorMsg = `Gagal memuat kegiatan sumber (ID: ${sourceId}): ${err?.response?.data?.message || err?.message || 'Server error'}`;
      }
    },
    calculateItemsToSync() {
      const type = this.syncState.type;
      const sourceKeg = this.syncState.sourceKeg;
      if (!sourceKeg) return;

      if (type === 'variabel') {
        const sourceItems = sourceKeg.ms_var || [];
        const currentItems = this.msVar.items || [];
        const existingNames = new Set(
          currentItems.map(i => (i.data?.nama || i.name || '').trim().toLowerCase()).filter(Boolean)
        );
        
        this.syncState.allItems = sourceItems;
        this.syncState.existingCount = sourceItems.filter(i => {
          const name = (i.data?.nama || i.name || '').trim().toLowerCase();
          return existingNames.has(name);
        }).length;

        this.syncState.missingItems = sourceItems.filter(i => {
          const name = (i.data?.nama || i.name || '').trim().toLowerCase();
          return !existingNames.has(name);
        });
      } else {
        const sourceItems = sourceKeg.ms_ind || [];
        const currentItems = this.msInd.items || [];
        const existingNames = new Set(
          currentItems.map(i => (i.data?.nama || i.name || '').trim().toLowerCase()).filter(Boolean)
        );

        this.syncState.allItems = sourceItems;
        this.syncState.existingCount = sourceItems.filter(i => {
          const name = (i.data?.nama || i.name || '').trim().toLowerCase();
          return existingNames.has(name);
        }).length;

        this.syncState.missingItems = sourceItems.filter(i => {
          const name = (i.data?.nama || i.name || '').trim().toLowerCase();
          return !existingNames.has(name);
        });
      }

      this.updateItemsToProcess();
    },
    updateItemsToProcess() {
      if (this.syncState.onlyMissing) {
        this.syncState.itemsToProcess = this.syncState.missingItems;
      } else {
        this.syncState.itemsToProcess = this.syncState.allItems;
      }
    },
    appendSyncLog(text, level = 'info') {
      const colors = {
        info: '#9cdcfe',
        success: '#4ec9b0',
        error: '#f48771',
        warn: '#dcdcaa',
        step: '#569cd6'
      };
      const ts = new Date().toLocaleTimeString();
      const safe = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      this.syncState.logs.push(`<span style="color:#888">[${ts}]</span> <span style="color:${colors[level] || colors.info}">${safe}</span>`);
      this.$nextTick(() => {
        const el = document.getElementById('sync-console-log');
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    async executeSync() {
      this.syncState.step = 'processing';
      this.syncState.logs = [];
      this.syncState.progress = { done: 0, failed: 0, total: this.syncState.itemsToProcess.length };
      this.syncState.isSyncing = true;
      
      const mskeg_id = this.msKeg.id;
      const date = new Date();
      const type = this.syncState.type;
      const items = this.syncState.itemsToProcess;

      this.appendSyncLog(`Memulai sinkronisasi ${items.length} ${type} ke Kegiatan ID ${mskeg_id}...`, 'step');

      for (let i = 0; i < items.length; i++) {
        const rawItem = items[i];
        let name = '-';
        try {
          if (type === 'variabel') {
            const data = this.normalizeMsVarData(rawItem);
            name = data?.nama || rawItem.name || `Var #${i+1}`;
            this.appendSyncLog(`[${i+1}/${items.length}] Mengirim MS-Var "${name}"...`, 'step');
            await this.$nextTick();
            const form = this.buildMsVarForm(mskeg_id, data, date);
            await MsService.saveNewMsVar(form);
            this.appendSyncLog(`  ✓ [${i+1}/${items.length}] MS-Var "${name}" BERHASIL (DRAFT)`, 'success');
            this.syncState.progress.done += 1;
          } else {
            const data = this.normalizeMsIndData(rawItem);
            name = data?.nama || rawItem.name || `Ind #${i+1}`;
            this.appendSyncLog(`[${i+1}/${items.length}] Mengirim MS-Ind "${name}"...`, 'step');
            await this.$nextTick();
            const form = this.buildMsIndForm(mskeg_id, data, date);
            await MsService.saveNewMsInd(form);
            this.appendSyncLog(`  ✓ [${i+1}/${items.length}] MS-Ind "${name}" BERHASIL (DRAFT)`, 'success');
            this.syncState.progress.done += 1;
          }
        } catch (err) {
          console.error(`[Sync ${type}] error on item ${i+1}:`, err);
          const errMsg = err?.response?.data?.message || err?.response?.statusText || err?.message || 'Gagal menyimpan';
          this.appendSyncLog(`  ✗ [${i+1}/${items.length}] GAGAL: "${name}" (${errMsg})`, 'error');
          this.syncState.progress.failed += 1;
        }

        // Delay 120ms to prevent server overload
        await new Promise(r => setTimeout(r, 120));
        await this.$nextTick();
      }

      this.appendSyncLog(`=== Sinkronisasi selesai. Berhasil: ${this.syncState.progress.done}, Gagal: ${this.syncState.progress.failed} ===`, this.syncState.progress.failed > 0 ? 'warn' : 'success');
      this.syncState.step = 'done';
      this.syncState.isSyncing = false;
      await this.getDetailMsKeg();
    },
    normalizeMsVarData(msvarItem) {
      let data = msvarItem.data || {};
      if (msvarItem.version === 'v1' || !data.nama) {
        let variable = msvarItem.data || msvarItem;
        data = {
          nama: variable.nama || variable.name,
          alias: variable.alias,
          konsep: variable.konsep ? [variable.konsep] : [null],
          definisi: variable.definisi,
          referensi_pemilihan: variable.referensiPemilihan && variable.referensiPemilihan.length > 0 ? variable.referensiPemilihan.map(x => x.nama || x) : [],
          referensi_waktu: variable.referensiWaktu,
          ukuran: variable.ukuran,
          satuan: variable.satuan,
          tipe_data: variable.tipeData,
          value_domain: variable.valueDomain && variable.valueDomain.length > 0 ? variable.valueDomain : [],
          aturan_validasi: variable.aturanValidasi && variable.aturanValidasi.length > 0 ? variable.aturanValidasi : [null],
          kalimat_pertanyaan: variable.kalimatPertanyaan,
          apakah_variabel_bisa_diakses_umum: variable.apakahVariabelBisaDiaksesUmum,
          id_sds: null,
        };
      }
      if (!data.value_domain || !Array.isArray(data.value_domain)) {
        data.value_domain = [];
      }
      if (!data.referensi_pemilihan || !Array.isArray(data.referensi_pemilihan)) {
        data.referensi_pemilihan = [];
      }
      if (!data.aturan_validasi || !Array.isArray(data.aturan_validasi)) {
        data.aturan_validasi = [null];
      }
      return data;
    },
    buildMsVarForm(mskeg_id, data, date) {
      return {
        ms_keg_id: mskeg_id,
        submission_period: this.msKeg.submission_period || date.getFullYear(),
        data: data,
        reviews: null,
        status: "DRAFT",
        rejection_note: null,
        submitter: this.user,
        produsen_data: {
          id: this.msKeg.produsen_data_id,
          name: this.msKeg.produsen_data_name,
          province_code: this.msKeg.produsen_data_province_code,
          city_code: this.msKeg.produsen_data_city_code
        },
        walidata_pusat: {
          id: this.msKeg.walidata_pusat_id,
          name: this.msKeg.walidata_pusat_name
        },
        version: 'v2',
        changes: null,
      };
    },
    normalizeMsIndData(msindItem) {
      let data = msindItem.data || {};
      if (msindItem.version === 'v1' || !data.nama) {
        let indikator = msindItem.data || msindItem;
        data = {
          nama: indikator.nama || indikator.name,
          konsep: indikator.konsep ? [indikator.konsep] : [null],
          definisi: indikator.definisi,
          interpretasi: indikator.interpretasi,
          metode_perhitungan: indikator.metodeAtauRumusPerhitungan || indikator.metode_perhitungan,
          rumus: null,
          ukuran: indikator.ukuran,
          satuan: indikator.satuan,
          variabel_disaggregasi: indikator.variabelDisaggregasi && indikator.variabelDisaggregasi.length > 0 ? indikator.variabelDisaggregasi : [{ nama: null, sumber: 'input-manual' }],
          apakah_indikator_komposit: indikator.apakahIndikatorKomposit,
          indikator_pembangun: indikator.indikatorPembangun && indikator.indikatorPembangun.length > 0 ? indikator.indikatorPembangun.map(x => ({
            nama: x.nama,
            sumber_publikasi: x.ketersediaanPublikasi ? x.ketersediaanPublikasi.map(k => k.nama || k) : []
          })) : [],
          variabel_pembangun: indikator.variabelPembangun && indikator.variabelPembangun.length > 0 ? indikator.variabelPembangun.map(x => ({
            nama: x.nama,
            kegiatan_penghasil: x.kegiatanPenghasil || x.kegiatan_penghasil
          })) : [],
          level_estimasi: indikator.levelEstimasi || indikator.level_estimasi,
          apakah_indikator_bisa_diakses_umum: indikator.apakahIndikatorBisaDiaksesUmum,
          id_sds: null
        };
        data.variabel_disaggregasi = data.variabel_disaggregasi.map(x => {
          if (typeof x === 'string' || x === null) {
            return data.id_sds ? { nama: x, sumber: 'sds' } : { nama: x, sumber: 'input-manual' };
          }
          return x;
        });
      }
      if (!data.variabel_disaggregasi || !Array.isArray(data.variabel_disaggregasi)) {
        data.variabel_disaggregasi = [{ nama: null, sumber: 'input-manual' }];
      }
      if (!data.indikator_pembangun || !Array.isArray(data.indikator_pembangun)) {
        data.indikator_pembangun = [];
      }
      if (!data.variabel_pembangun || !Array.isArray(data.variabel_pembangun)) {
        data.variabel_pembangun = [];
      }
      return data;
    },
    buildMsIndForm(mskeg_id, data, date) {
      return {
        ms_keg_id: mskeg_id,
        submission_period: this.msKeg.submission_period || date.getFullYear(),
        data: data,
        reviews: null,
        status: "DRAFT",
        rejection_note: null,
        submitter: this.user,
        produsen_data: {
          id: this.msKeg.produsen_data_id,
          name: this.msKeg.produsen_data_name,
          province_code: this.msKeg.produsen_data_province_code,
          city_code: this.msKeg.produsen_data_city_code
        },
        walidata_pusat: {
          id: this.msKeg.walidata_pusat_id,
          name: this.msKeg.walidata_pusat_name
        },
        version: 'v2',
        changes: null,
      };
    },
    closeSyncModal() {
      this.$bvModal.hide('modal-sync-metadata');
      this.syncState.step = 'preview';
      this.syncState.logs = [];
      this.syncState.isSyncing = false;
    }
  }
};
</script>

<style lang="scss">
.modal-sync {
  border-radius: 8px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .modal-header {
    padding: 12px 18px !important;
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }

  .modal-body {
    padding: 0 !important;
  }

  .modal-footer {
    padding: 12px 20px !important;
    background-color: #f8fafc;
    border-top: 1px solid #e2e8f0;
  }
}
</style>
